import axios from '@/utils/request';
import { isInApp } from '@/utils/utils'

export const APP_CODE = 'activity-platform';
export const SUB_APP_CODE = 'activity-mini-manage-api';

// 上传
function upload(url, fileData, params = {}, otherData = {}) {
  const formData = new FormData();

  if (Array.isArray(fileData)) {
    fileData.forEach((item) => formData.append('files', item, item.name));
  } else {
    formData.set('file', fileData, fileData.name);
  }

  for (const [key, value] of Object.entries(otherData)) {
    if (key) {
      formData.append(key, value);
    }
  }
  
  return axios.post(url, formData, {
    params,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 用户鉴权接口
export const common = {
  login(parmes) {
    return axios.get('/activity-mini-manage-api/h5/login', {
      params: {
        ...parmes
      }
    });
  },
  confirmLoginUser(data) {
    return axios.post('/activity-mini-manage-api/h5/confirmLoginUser',data)
  },
  getLoginUserList(data) {
    return axios.get('/activity-mini-manage-api/h5/getLoginUserList', {
      params: {
        ...data
      }
    })
  },
  getUserInfo(openId) {
    return axios.get('/activity-mini-manage-api/h5/userInfo', {
      params: {
        openId
      }
    });
  },
  uploadImg(fileData, otherData = {}) {
    otherData = {
      appCode: SUB_APP_CODE,
      compressFlag: 'Y',
      scale: 80,
      ...otherData
    };
    return upload('/qu-file-upload-api/upload/app/uploadImg', 
        Array.isArray(fileData) ? fileData : [fileData], 
        {}, 
        otherData
      );
  },
  uploadVideo(fileData) {
    return upload('/qu-file-upload-api/upload/app/uploadVideo', 
      fileData, 
      {}, 
      {
        appCode: SUB_APP_CODE,
      });
  },
  deleteFile(filePath) {
    return axios.post('/qu-file-upload-api/upload/file/delete', [filePath]);
  },
  deleteImg(data) {
    return axios.post('/activity-mini-manage-api/activity/deletePictureOrVideo', data);
  },
  checkPhoneNumExisted(mobileNo) {
    return axios.get(`/activity-mini-manage-api/h5/mobileNo/check`, {
      params: {
        mobileNo
      }
    });
  },
  sendSMSCode(mobileNo, name) {
    return axios.get(`/activity-mini-manage-api/h5/sms/captcha`, {
      params: {
        mobileNo
      }
    });
  },
  bindMobile(data) {
    return axios.post('/activity-mini-manage-api/h5/mobileNo/bind', data);
  },
  // 微信api签名
  getJsApiSign(url) {
    return axios.get('/activity-mini-manage-api/h5/signature', {
      params: {
        url
      }
    })
  },
  // 检查当前账号进件信息 
  findJJInfo() {
    return axios.post(`/activity-mini-manage-api/withdrawal/findJJInfo`,{})
  },
};

export const activityMgmt = {
  dataExport(data) {
    return axios.post(`/activity-mini-manage-api/data/export/cusDataReportExport`, data);
  },
  getTemplateList(data) {
    return axios.post(`/activity-mini-manage-api/activity/tmp/queryActivityTmps`, data);
  },
  getTemplateInfoById(tmpId) {
    return axios.get(`/activity-mini-manage-api/activity/tmp/getTmpById/${tmpId}`);
  },
  saveActivity(data) {
    return axios.post(`/activity-mini-manage-api/activity/saveActivity`, data);
  },
  // 查询活动信息
  getActivityInfoById(activityId) {
    return axios.get(`/activity-mini-manage-api/activity/getActivity/${activityId}`);
  },
  // 获取草稿箱克隆活动信息
  getCloneOrDraftsActivityInfoById(activityId) {
    return axios.get(`/activity-mini-manage-api/activity/getActivityCleanUpMarketing/${activityId}`);
  },
  // 查询活动编辑页信息
  getActivityEditDataById(activityId) {
    return axios.get(`/activity-mini-manage-api/activity/getActivityEditData/${activityId}`);
  },
  // 保存活动编辑页
  editActivity(data) {
    return axios.post(`/activity-mini-manage-api/activity/editActivity`, data);
  },
  getPayInfoBeforeRelease(activityId) {
    return axios.get(`/activity-mini-manage-api/activity/getWechatPayParamsActivity/${activityId}`);
  },
  // 发布活动
  releaseActivity(data) {
    return axios.post(`/activity-mini-manage-api/activity/releaseActivity`, data);
  },
  getPostersById(activityId) {
    return axios.get(`/activity-mini-manage-api/activity/getActivityPoster/${activityId}`);
  },
  // 获取带小程序码的海报图
  getPosterWithCode(data) {
    return axios.post(`/activity-mini-manage-api/h5/poster`, data);
  },
  // 保存分享参数
  getShareScene(data) {
    return axios.post(`/activity-mini-manage-api/activity/saveActivityQrcodeParams`, data);
  },
  deletePoster(posterId) {
    return axios.get(`/activity-mini-manage-api/activity/deleteActivityPoster/${posterId}`);
  },
  addPoster(data) {
    return axios.post(`/activity-mini-manage-api/activity/addActivityPoster`, data);
  },
  // 修改虚拟数据，任务设置，参与轮播
  saveSignUpConf(data) {
    return axios.post(`/activity-mini-manage-api/activity/editActivityModuleConfig`, data);
  },
  saveCommonConf(data) {
    return axios.post(`/activity-mini-manage-api/activity/editActivityconfig`, data);
  },
  // 查询附加活动信息
  getAdditionalConfById(activityId) {
    return axios.get(`/activity-mini-manage-api/activity/getActivityAppendEditData/${activityId}`);
  },
  // 保存附加活动配置：红包配置
  saveRedPacketConf(data) {
    return axios.post(`/activity-mini-manage-api/activity/editActivityAppend`, data);
  },
  // 查询参与活动信息
  getJoinActivityInfoById(activityId) {
    return axios.get(`/activity-mini-manage-api/activity/getActivityJoinPageData/${activityId}`);
  },
  // 加入活动
  joinActivity(activityId) {
    return axios.get(`/activity-mini-manage-api/activity/immediatelyJoin/${activityId}`);
  },
  // 红包充值
  rechargeToRedPacket(data) {
    return axios.post(`/activity-mini-manage-api/activity/addRedpack`, data);
  },
  // 裂变佣金充值
  fissionWalletRecharge(data) {
    return axios.post(`/activity-mini-manage-api/activity/fissionWalletRecharge`,data)
  },
  // 抽奖充值
  lotteryWalletRecharge(data) {
    return axios.post(`/activity-mini-manage-api/activity/lotteryWalletRecharge`,data)
  },
  // 红包充值记录
  getRedPacketRechargeRecords(data) {
    return axios.post(`/activity-mini-manage-api/activity/queryActivityRedpackAddList`, data);
  },
  getRedPacketRollingList(activityId) {
    return axios.get(`/activity-mini-manage-api/activity/getActivityRedPackRolling/${activityId}`);
  },
  // 红包使用记录 
  getActivityRedPackUseList(data) {
    return axios.post(`/activity-mini-manage-api/activity/getActivityRedPackUseList`,data);
  },
  // 导出列表 
  selectReportRecordList(data) {
    return axios.post(`/activity-mini-manage-api/data/export/selectReportRecordList`,data)
  },
  // 附件活动数据下载
  getRedReport(activityId) {
    return axios.get(`/activity-mini-manage-api/data/export/getRedReport/${activityId}`)
  },
  // 排行榜生成虚拟数据 
  createVirtualData(data) {
    return axios.post(`/activity-mini-manage-api/activity/createVirtualData`,data)
  },
  // 获取小程序链接 
  urlLink(data) {
    return axios.get(`/activity-mini-manage-api/h5/mini/urlLink/${data.activityId}/${data.h5UserId}/${data.envVersion}`)
  },
  // 查询当前用户创建的活动id 
  selectActivityList() {
    return axios.get(`/activity-mini-manage-api/data/export/selectActivityList`)
  }
}

export const h5 = {
  home(data) {
    return axios.request({
      url: '/activity-mini-manage-api/activity/pageList',
      method: 'post',
      data
    })
  },
  queryRollings(data) {
    return axios.request({
      url: '/activity-mini-manage-api/rollingConfig/queryRollings',
      method: 'post',
      data
    })
  },
  deleteActivity(activityId) {
    return axios.request({
      url: `/activity-mini-manage-api/activity/deleteActivityDraft/${activityId}`,
      method: 'get'
    })
  },
  // 获取活动统计列表数据 H5端活动数据页面
  queryActivityStatisticList(data) {
    return axios.request({
      url: `/activity-mini-manage-api/activityStatistic/queryActivityStatisticList`,
      method: 'post',
      data
    })
  },
  // 获取具体活动参与经销商列表数据
  queryDealerActivityStatisticList(data) {
    return axios.request({
      url: `/activity-mini-manage-api/activityStatistic/queryDealerActivityStatisticList`,
      method: 'post',
      data
    })
  },
  // 获取具体活动参与门店列表数据
  queryStoreActivityStatisticList(data) {
    return axios.request({
      url: `/activity-mini-manage-api/activityStatistic/queryStoreActivityStatisticList`,
      method: 'post',
      data
    })
  },
  // 获取具体活动参与职员列表数据
  queryStaffActivityStatisticList(data) {
    return axios.request({
      url: `/activity-mini-manage-api/activityStatistic/queryStaffActivityStatisticList`,
      method: 'post',
      data
    })
  },
  // 获取具体活动小程序端参与用户列表数据
  queryAppUserActivityStatisticList(data) {
    return axios.request({
      url: `/activity-mini-manage-api/activityStatistic/queryAppUserActivityStatisticList`,
      method: 'post',
      data
    })
  },
  // H5端获取活动任务数据
  getActivityMissionData(activityId) {
    return axios.request({
      url: `/activity-mini-manage-api/activityStatistic/getActivityMissionData/${activityId}`,
      method: 'get'
    })
  },
  // 获取任务详情
  getActivityTaskDetails(data) {
    return axios.request({
      url: `/activity-mini-manage-api/activityStatistic/getActivityMissionDetailList`,
      method: 'post',
      data
    })
  },
  // 通过活动ID获取活动整体统计数据
  getActivityStatistic(activityId) {
    return axios.request({
      url: `/activity-mini-manage-api/activityStatistic/getActivityStatistic/${activityId}`,
      method: 'get'
    })
  },
  // 通过ID获取个人活动数据
  getActivityStatisticByUserId(activityId, userId) {
    return axios.request({
      url: `/activity-mini-manage-api/activityStatistic/getActivityStatistic/${activityId}/${userId}`,
      method: 'get'
    })
  },
  // 获取活动简要信息
  activitySimpleData(activityId) {
    return axios.request({
      url: `/activity-mini-manage-api/activity/activitySimpleData/${activityId}`,
      method: 'get'
    })
  },
  // 关闭活动
  closeActivity(activityId) {
    return axios.request({
      url: `/activity-mini-manage-api/activity/closeActivity/${activityId}`,
      method: 'get'
    })
  },
  changeUserTag(joinLogId, signupTag) {
    return axios.get(`/activity-mini-manage-api/activityStatistic/updateUserSignUpTag/${joinLogId}/${signupTag}`);
  },
  updateCustomerTag(joinLogId,customerTag,sourceType) {
    return axios.get(`/activity-mini-manage-api/activityStatistic/updateCustomerTag/${joinLogId}/${customerTag}/${sourceType}`);
  },
  // 查询宣传信息
  publicityInfo(pageType) {
    return axios.get(`/activity-mini-manage-api/rollingConfig/queryPublicityData/${pageType || ''}`)
  },
  // 取活动报名数据
  getActivitySignupData(data) {
    return axios.post(`/activity-mini-manage-api/activityStatistic/getActivitySignupData`,data)
  },
  // 获取数据字典
  queryPublicityData(typeCode) {
    return axios.get(`/activity-mini-manage-api/dict/getDictDataMap/${typeCode}`)
  },
  // 解绑绑定 
  unBinding() {
    return axios.post(`/activity-mini-manage-api/h5/unBinding`,{})
  },
  // 是否显示引导页
  getPopupInfo() {
    return axios.get(`/activity-mini-manage-api/activity/getPopupInfo`)
  },
  // 设置引导页 
  setPopup() {
    return axios.get(`/activity-mini-manage-api/activity/setPopup`)
  },
  // yoyo环境退出登录 
  unXcxBinding() {
    return axios.post(`/activity-mini-manage-api/h5/unXcxBinding`)
  },
  // 轮询查询支付状态 
  getRechargeOrderStatus(orderNo) {
    return axios.get(`/activity-mini-manage-api/activity/getRechargeOrderStatus/${orderNo}`)
  },
  // 获取部门 
  userSaleShopInfo() {
    return axios.get(`/activity-mini-manage-api/h5/userSaleShopInfo`)
  },
  // 切换用户销售部门
  setSaleShop(data) {
    return axios.post(`/activity-mini-manage-api/h5/setSaleShop`,data)
  }
}

// 活动管理员
export const activityManager = {
  getList(data) {
    return axios.post(`/activity-mini-manage-api/activityManager/queryActivityManagerList`, data);
  },
  getListToAdd(data) {
    return axios.post(`/activity-mini-manage-api/activityManager/queryActivityManagerAddList`, data);
  },
  add(data) {
    return axios.post(`/activity-mini-manage-api/activityManager/addActivityManager`, data);
  },
  remove(data) {
    return axios.post(`/activity-mini-manage-api/activityManager/removeActivityManager`, data);
  }
}

// 核销
export const verification = {
  getSignUpInfo(joinLogId) {
    return axios.get(`/activity-mini-manage-api/verification/getSignUpData/${joinLogId}`);
  },
  verifySign(data) {
    return axios.post(`/activity-mini-manage-api/verification/userVerification`, data);
  },
  // 秒杀订单核销
  seckillVerification(data) {
    return axios.post(`/activity-mini-manage-api/verification/seckillVerification`,data)
  },
  // 获取当前经销商-办事处是否能自动核销
  getAutoVerification() {
    return axios.get(`/activity-mini-manage-api/activity/getAutoVerification`);
  }
}

// 客户列表
export const customerList = {
  getDataList(data) {
    return axios.post(`/activity-mini-manage-api/activityStatistic/queryActivityAppUserList`, data);
  },
  // 同意退款 
  agreeRefund(orderNo) {
    return axios.get(`/activity-mini-manage-api/audit/agreeRefund/${orderNo}`)
  },
  // 拒绝退款 
  rejectRefund(data) {
    return axios.post(`/activity-mini-manage-api/audit/rejectRefund`,data)
  },
  // 获取待退款信息
  findRefundInfo() {
    return axios.get(`/activity-mini-manage-api/activityStatistic/findRefundInfo`)
  },
  // 线下退款
  offlineRefund(data) {
    return axios.post(`/activity-mini-manage-api/audit/offlineRefund`,data)
  }
}

// 提现
export const withdrawal = {
  // 短信验证
  getWithdrawalSms(data) {
    return axios.post(`/activity-mini-manage-api/withdrawal/sms`,data)
  },
  getBindingInfo() {
    return axios.post(`/activity-mini-manage-api/withdrawal/getBindingInfo`,{})
  },
  // 经销商账号绑定信息验证
  bindingVerify(data) {
    return axios.post(`/activity-mini-manage-api/withdrawal/bindingVerify`,data)
  },
  // 获取经销商钱包信息
  customerWalletInfo() {
    return axios.post(`/activity-mini-manage-api/withdrawal/customerWalletInfo`, {})
  },
  // 经销商账号解绑
  accountUnBinding(data) {
    return axios.get(`/activity-mini-manage-api/withdrawal/accountUnBinding/${data.userId}/${data.type}`)
  },
  // 申请提现 
  applyWithdrawal(data) {
    return axios.post(`/activity-mini-manage-api/withdrawal/applyWithdrawal`, data)
  },
  // 获取可用提现额度
  availableWithdrawalInfo() {
    return axios.post(`/activity-mini-manage-api/withdrawal/availableWithdrawalInfo`, {})
  },
  // 查询经销商钱包流水记录
  queryWalletLogList(data) {
    return axios.post(`/activity-mini-manage-api/withdrawal/queryWalletLogList`,data)
  },
  // 获取绑定经销商信息 
  getBindingInfo() {
    return axios.post(`/activity-mini-manage-api/withdrawal/getBindingInfo`,{})
  },
  // 查询职员名单列表 
  queryStaffList(data) {
    return axios.post(`/activity-mini-manage-api/withdrawal/queryStaffList`,data)
  },
  // 搜索职员 
  querySearchStaffList(data) {
    return axios.post(`/activity-mini-manage-api/withdrawal/querySearchStaffList`,data)
  },
  // 检查当前登录人是否可以提现 
  checkIsWithdrawal() {
    return axios.post(`/activity-mini-manage-api/withdrawal/checkIsWithdrawal`,{})
  },
  // 获取已绑定名单信息 
  findBindingInfo(data) {
    return axios.post(`/activity-mini-manage-api/withdrawal/findBindingInfo`,data)
  },
  // 查询银联商户入账资金明细
  queryMerchantInList(data) {
    return axios.post(`/activity-mini-manage-api/activityStatistic/queryMerchantInList`,data)
  },
  // 银联余额查询
  unionPayBalance() {
    return axios.post(`/activity-mini-manage-api/withdrawal/unionPay/balance`,{})
  },
  // 银联申请提现
  unionApplyWithdrawal(data) {
    return axios.post(`/activity-mini-manage-api/withdrawal/unionApplyWithdrawal`,data)
  },
  // 保证金提现
  frozenMarginWithdrawApply(data) {
    return axios.post(`/activity-mini-manage-api/withdrawal/unionPay/frozenMarginWithdrawApply`,data)
  }
}

// 抽奖
export const luckDraw = {
  edit(data) {
    return axios.post(`/activity-mini-manage-api/activity/editActivityLotteryAward`,data)
  },
  delete(data) {
    return axios.get(`/activity-mini-manage-api/activity/deleteActivityLotteryAward/${data.activityId}/${data.moduleId}/${data.moduleGroupCode}`)
  },
  lotterConfigData(activityId) {
    return axios.get(`/activity-mini-manage-api/activity/getActivityLotteryConfigData/${activityId}`)
  },
  editActivityLotteryConfig(data){
    return axios.post(`/activity-mini-manage-api/activity/editActivityLotteryConfig`,data)
  },
  getActivityAwards(activityId) {
    return axios.get(`/activity-mini-manage-api/lottery/getActivityAwards/${activityId}`)
  },
  // 中奖线索
  queryLotteryRecordPageList(data) {
    return axios.post(`/activity-mini-manage-api/activity/queryLotteryRecordPageList`,data)
  },
  // 获取钱包余额
  getActivityWalletBalance(data) {
    return axios.get(`/activity-mini-manage-api/activity/getActivityWalletBalance/${data.activityId}/${data.walletType}`)
  },
  // 抽奖核销
  getLotteryData(id) {
    return axios.get(`/activity-mini-manage-api/verification/getLotteryData/${id}`)
  },
  // 扫码兑换奖品
  lotteryVerification(data) {
    return axios.post(`/activity-mini-manage-api/verification/lotteryVerification`,data)
  }
}
// 直播 
export const live = {
  queryLiveRooms() {
    return axios.post('/activity-mini-manage-api/liveRoom/queryLiveRooms',{
      filterData: {},
      pageNum: 1,
      pageSize: 1000
    })
  }
}
// 问答
export const question = {
  // 获取背景音乐
  getBackgroundMusicList() {
    return axios.get('/activity-mini-manage-api/question/getBackgroundMusicList')
  },
  // 更换背景音乐 
  changeBackgroundMusic(data) {
    return axios.get(`/activity-mini-manage-api/question/changeBackgroundMusic`,{
      params: data
    })
  },
  // 保存试题
  saveQuestions(data) {
    return axios.post(`/activity-mini-manage-api/question/saveQuestions`,data)
  },
  // 保存试卷 
  saveQuestionBaseDetail(data) {
    return axios.post(`/activity-mini-manage-api/question/saveQuestionBaseDetail`,data)
  },
  // 查询试题 
  queryQuestionList(data) {
    return axios.post(`/activity-mini-manage-api/question/queryQuestionList`,data)
  },
  // 查询试卷基本信息
  queryQuestionDetail(data) {
    return axios.post(`/activity-mini-manage-api/question/queryQuestionDetail`,data)
  },
  // 获取题库列表 
  queryBaseQuestionGroupList(data) {
    return axios.post(`/activity-mini-manage-api/question/queryBaseQuestionGroupList`,data)
  },
  // 获取题目数量 
  queryQuestionTotalNumber(data) {
    return axios.post(`/activity-mini-manage-api/question/queryQuestionTotalNumber`,data)
  },
  // 获取试题详情
  queryActivityQuestion(activityId) {
    return axios.get(`/activity-mini-manage-api/question/queryActivityQuestion`,{
      params: {
        activityId: activityId
      }
    })
  },
 // 克隆活动 
 questionClone(activityId) {
  return axios.get(`/activity-mini-manage-api/question/questionClone/${activityId}`)
 },
}
// 秒杀
export const spike = {
  // 获取新增场次id
  getNextSectionId() {
    return axios.get(`/activity-mini-manage-api/spike/getNextSectionId`)
  },
  // 保存商品
  saveGoods(data) {
    return axios.post(`/activity-mini-manage-api/spike/saveGoods`, data)
  },
  // 删除场次  
  deleteSection(data) {
    return axios.get(`/activity-mini-manage-api/spike/deleteSection/${data.activityId}/${data.sectionId}`)
  },
  // 商品下架
  deleteGoods(data) {
    return axios.get(`/activity-mini-manage-api/spike/deleteGoods/${data.activityId}/${data.goodsId}`)
  },
  // 核销秒杀详情 
  getSeckillOrder(id) {
    return axios.get(`/activity-mini-manage-api/verification/getSeckillOrder/${id}`)
  },
  // 编辑并下架 
  edit(data) {
    return axios.get(`/activity-mini-manage-api/spike/edit/${data.activityId}/${data.goodsId}/${data.sectionId}`)
  },
  // 获取秒杀轮播
  getSeckillRolling(activityId) {
    return axios.get(`/activity-mini-manage-api/spike/getSeckillRolling/${activityId}`)
  },
  // 秒杀商品已售数量 
  goodsSoldNumber(goodsId) {
    return axios.get(`/activity-mini-manage-api/spike/goodsSoldNumber/${goodsId}`)
  }
}
// 拼图
export const connectPic = { 
  // 获取裁剪图片
  imgCut(data) {
    return axios.post(`/activity-mini-manage-api/connectPic/imgCut`,data)
  },
  getConnectPicBase64Img(activityId) {
    return axios.get(`/activity-mini-manage-api/connectPic/getConnectPicBase64Img/${activityId}`)
  }
}
// 拼团
export const groupBuying = {
  // 商品下架 
  goodsOffline(data) {
    return axios.get(`/activity-mini-manage-api/groupBuying/goodsOffline/${data.activityId}/${data.goodsId}`)
  },
  // 拼团已售数量
  goodsSoldNumber(goodsId) {
    return axios.get(`/activity-mini-manage-api/groupBuying/goodsSoldNumber/${goodsId}`)
  },
  // 商品保存并上架
  saveGoodsAndOnline(data) {
    return axios.post(`/activity-mini-manage-api/groupBuying/saveGoodsAndOnline`,data)
  },
  // 删除商品 
  deleteGoods(data) {
    return axios.get(`/activity-mini-manage-api/groupBuying/deleteGoods/${data.activityId}/${data.goodsId}`)
  },
  // 拼团组件信息 
  getGroupInfo(activityId) {
    return axios.get(`/activity-mini-manage-api/groupBuying/getGroupInfo/${activityId}`)
  },
  // 获取核销信息 
  getGroupBuyingOrderInfo(id) {
    return axios.get(`/activity-mini-manage-api/verification/getGroupBuyingOrderInfo/${id}`)
  },
  // 拼团核销 
  groupBuyingVerification(data) {
    return axios.post(`/activity-mini-manage-api/verification/groupBuyingVerification`,data)
  }
}

// 抽签
export const drawlots = {
  getDictData(typeCode) {
    return axios.get(`/activity-mini-manage-api/dict/getDictData/${typeCode}`)
  },
  // 删除商品 
  deletePrize(data) {
    return axios.get(`/activity-mini-manage-api/drawLots/deletePrize/${data.activityId}/${data.prizeId}`)
  },
  // 签编辑并下架 
  drawLotsEdit(data) {
    return axios.get(`/activity-mini-manage-api/drawLots/drawLotsEdit/${data.activityId}/${data.drawLotsId}`)
  },
  // 奖品下架并编辑
  prizeEdit(data) {
    return axios.get(`/activity-mini-manage-api/drawLots/prizeEdit//${data.activityId}/${data.prizeId}`)
  },
  // 获取已兑换奖品 
  getPrize(prizeId) {
    return axios.get(`/activity-mini-manage-api/drawLots/getPrize/${prizeId}`)
  },
  // 奖品保存并上架 
  savePrizeAndOnline(data) {
    return axios.post(`/activity-mini-manage-api/drawLots/savePrizeAndOnline`,data)
  },
  // 签保存并上架 
  saveDrawLotsAndOnline(data) {
    return axios.post(`/activity-mini-manage-api/drawLots/saveDrawLotsAndOnline`,data)
  },
  // 获取签详情 
  getDrawLots(drawLotsId) {
    return axios.get(`/activity-mini-manage-api/drawLots/getDrawLots/${drawLotsId}`)
  },
  // 获取核销详情
  getExchangeRecordInfo(id) {
    return axios.get(`/activity-mini-manage-api/verification/getExchangeRecordInfo/${id}`)
  },
  // 核销 
  exchangePrizeVerification(data) {
    return axios.post(`/activity-mini-manage-api/verification/exchangePrizeVerification`,data)
  }
}

// 帮助中心
export const help = {
  // 查询帮助与培训文档列表
  queryDocuments(data) {
    return axios.post(`/activity-mini-manage-api/document/queryDocuments`,data)
  },
  // 详情 
  queryDocumentDetail(data) {
    return axios.post(`/activity-mini-manage-api/document/queryDocumentDetail`,data)
  }
}

// 风格测试
export const typeTest = {
  // 保存活动
  saveStylePage(data) {
    return axios.post(`/activity-mini-manage-api/stylePage/saveStylePage`,data)
  },
  // 删除页面信息
  deleteStylePage(data) {
    return axios.get(`/activity-mini-manage-api/stylePage/deleteStylePage/${data.activityId}/${data.id}`)
  }
}

// 红包挑战赛
export const countMoney = {
  // 核销详情 
  getCountMoneyPrize(id) {
    return axios.get(`/activity-mini-manage-api/verification/getCountExchangeRecordInfo/${id}`)
  },
  // 核销
  countMoneyPrizeWriteOff(data) {
    return axios.post(`/activity-mini-manage-api/verification/countExchangePrizeVerification`,data)
  },
  // 获取背景音乐 
  getMusicList() {
    return axios.get(`/activity-mini-manage-api/question/getCountMoneyBackgroundMusicList`)
  }
}

// 优惠券 
export const coupon = {
   // 核销详情 
   getCountMoneyPrize(orderNo) {
    return axios.get(`/activity-mini-manage-api/verification/getCouponOrderInfo/${orderNo}`)
  },
   // 优惠券核销 
   couponVerification(data) {
    return axios.post(`/activity-mini-manage-api/verification/couponVerification`,data)
  },
}